/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Person } from './Person';
import {
    PersonFromJSON,
    PersonFromJSONTyped,
    PersonToJSON,
    PersonToJSONTyped,
} from './Person';

/**
 * 
 * @export
 * @interface ManagedTeamDetailsContract
 */
export interface ManagedTeamDetailsContract {
    /**
     * 
     * @type {string}
     * @memberof ManagedTeamDetailsContract
     */
    homeColor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManagedTeamDetailsContract
     */
    visitorColor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManagedTeamDetailsContract
     */
    goalkeepColor?: string | null;
    /**
     * 
     * @type {Person}
     * @memberof ManagedTeamDetailsContract
     */
    responsiblePerson?: Person;
    /**
     * 
     * @type {string}
     * @memberof ManagedTeamDetailsContract
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManagedTeamDetailsContract
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManagedTeamDetailsContract
     */
    city?: string | null;
}

/**
 * Check if a given object implements the ManagedTeamDetailsContract interface.
 */
export function instanceOfManagedTeamDetailsContract(value: object): value is ManagedTeamDetailsContract {
    return true;
}

export function ManagedTeamDetailsContractFromJSON(json: any): ManagedTeamDetailsContract {
    return ManagedTeamDetailsContractFromJSONTyped(json, false);
}

export function ManagedTeamDetailsContractFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManagedTeamDetailsContract {
    if (json == null) {
        return json;
    }
    return {
        
        'homeColor': json['home_color'] == null ? undefined : json['home_color'],
        'visitorColor': json['visitor_color'] == null ? undefined : json['visitor_color'],
        'goalkeepColor': json['goalkeep_color'] == null ? undefined : json['goalkeep_color'],
        'responsiblePerson': json['responsible_person'] == null ? undefined : PersonFromJSON(json['responsible_person']),
        'country': json['country'] == null ? undefined : json['country'],
        'state': json['state'] == null ? undefined : json['state'],
        'city': json['city'] == null ? undefined : json['city'],
    };
}

export function ManagedTeamDetailsContractToJSON(json: any): ManagedTeamDetailsContract {
    return ManagedTeamDetailsContractToJSONTyped(json, false);
}

export function ManagedTeamDetailsContractToJSONTyped(value?: ManagedTeamDetailsContract | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'home_color': value['homeColor'],
        'visitor_color': value['visitorColor'],
        'goalkeep_color': value['goalkeepColor'],
        'responsible_person': PersonToJSON(value['responsiblePerson']),
        'country': value['country'],
        'state': value['state'],
        'city': value['city'],
    };
}

